import Vue from "vue";

Vue.component("helper-icon", {
	props: ["codeToDisplay", "sizeDimension", "customDimension"],
	data() {
		return {
			textToDisplay: '',
			position: 'is-left'
		};
	},
	methods: {
		retrieveText: function () {
			this.$services.staticContents.getContent({
				code: this.codeToDisplay,
				language: window.currentLanguageInt
			})
				.then((data) => {
					this.textToDisplay = data.content;
			});
		}
	},
	mounted: function () {
		this.retrieveText();
		if (this.sizeDimension == "is-very-large")
			this.position = "is-right";
		else
			this.position = "is-left";

		if (this.customDimension)
			this.position = this.customDimension;
	},
	watch: {
		attachments: function (val) {
			this.files = val;
		}
	},
	template: `
		<b-tooltip multilined :size="sizeDimension"
			:position="position" style="margin-left:20px;">
			<b-icon class="file-icon info-icon" icon="info-circle" type="is-info"></b-icon>
			<template v-slot:content>
                <div class="tooltip-container" style="text-indent: 20px !important;" v-html="textToDisplay"></div>
            </template>
		</b-tooltip>
	`
});